export default class {

	constructor( el, active_tab_alias ){

		this.anchors = [ ...el.querySelectorAll(':scope > header > a') ];
		this.content = [ ... el.querySelectorAll(' :scope > header ~ * ')];
		this.active_idx = this.anchors.findIndex((a) => a.classList.contains('active'));

		if( active_tab_alias ){
			this.switch( this.anchors.findIndex((a) => a.getAttribute('data-alias') == active_tab_alias ) );
		}

		this.anchors.map(( anchor, idx ) => {
			anchor.addEventListener( 'click', ( e ) => {
				this.switch( idx );
			} )
		});

	}

	switch( idx ){

		this.anchors[this.active_idx].classList.remove('active');
		this.content[this.active_idx]?.classList.remove('active');

		this.anchors[idx].classList.add('active');
		this.content[idx]?.classList.add('active');

		this.active_idx = idx;


	}

}